import { postRequest} from "../libs/AxiosService.util";

export async function serviceCreateAdmin(params) {
  return await postRequest("clients/create", params);
}

export async function serviceUpdateAdmin(params) {
  return await postRequest("clients/update", params);
}

export async function serviceDeleteAdmin(params) {
  return await postRequest("clients/delete", params);
}
export async function serviceCheckAdmin(params) {
  return await postRequest("clients/check", params);
}

export async function serviceGetAdmin(params) {
  return await postRequest("admins", params);
}
export async function serviceGetAdminDetails(params) {
  return await postRequest("admins/details", params);
}
export async function serviceUpdateAdminPriority(params) {
  return await postRequest("roles/update/priority", params);
}
export async function serviceGetAssociateClients(params) {
  return await postRequest("admins/clients", params);
}
export async function serviceGetAssociatePrograms(params) {
  return await postRequest("admins/programs", params);
}



